const SUIT_GLYPH = {
    spades: '♠',
    hearts: '♥',
    diamonds: '♦',
    clubs: '♣',
    '*': '★',
};
const SUIT_COLOR = {
    spades: 'var(--ink)',
    hearts: 'var(--blood)',
    diamonds: 'var(--blood)',
    clubs: 'var(--ink)',
    '*': 'var(--brass)',
};
// Returns an HTML string for a playing card. Uses inline SVG for the suit
// glyph so it scales crisply. The aged-parchment look comes from CSS gradients
// declared in pirate.css; we just give each card the .pcard class plus
// data attrs the styles can hook into.
export function renderPlayingCard(card, opts) {
    const sel = opts?.selected ? ' pcard--selected' : '';
    const tiny = opts?.tiny ? ' pcard--tiny' : '';
    if (opts?.faceDown) {
        return `<div class="pcard pcard--back${tiny}" data-card-id="${card.id}">
      <div class="pcard-back-pattern">⚓</div>
    </div>`;
    }
    const glyph = SUIT_GLYPH[card.suit];
    const color = SUIT_COLOR[card.suit];
    const rankDisplay = card.rank === '*' ? '★' : card.rank;
    const wild = card.rank === '*' || card.suit === '*' ? ' pcard--wild' : '';
    return `<div class="pcard${sel}${tiny}${wild}" data-card-id="${card.id}" data-rank="${card.rank}" data-suit="${card.suit}" style="--suit-color:${color}">
    <div class="pcard-corner pcard-corner--tl">
      <div class="pcard-rank">${rankDisplay}</div>
      <div class="pcard-suit">${glyph}</div>
    </div>
    <div class="pcard-center">${glyph}</div>
    <div class="pcard-corner pcard-corner--br">
      <div class="pcard-rank">${rankDisplay}</div>
      <div class="pcard-suit">${glyph}</div>
    </div>
  </div>`;
}
export function suitGlyph(suit) {
    return SUIT_GLYPH[suit];
}
